import React from 'react'
import Spinner from '../spinner/spinner'
import { Outlet } from 'react-router-dom'
import useRouteChange from '@/presentation/hooks/navigate/use-route-change'
import { SCROLL_TOP_PARAMS } from '@/presentation/helpers/page/url-helper'

function RootLayout() {
  useRouteChange(() => {
    setTimeout(() => window.scrollTo(SCROLL_TOP_PARAMS), 0)
  })

  return (
    <React.Suspense fallback={<Spinner fullScreen />}>
      <Outlet />
    </React.Suspense>
  )
}

export default RootLayout
